<template>
<div v-show="isModalVisible">
    <div class="modal-mask" @click="closeModal">
        <div class="modal-container" @click.stop>
            <!-- Modal body -->
            <div class="modal-body">
                <h6 class="title" v-html="modalTitle"></h6>
                <div class="row mt-4" v-if="modalType == 'reset'">
                    <button 
                        name="cancel" 
                        id="cancel"
                        class="btn btn-sm ma-gray-btn mx-auto"
                        @click="closeModal">
                        Cancel
                    </button>
                    <button 
                        name="yes" 
                        id="yes"
                        class="btn btn-sm ma-blue-btn mx-auto"
                        @click="submit()">
                        Yes
                    </button>
                </div>
                <div class="row mt-4" v-else>
                    <button 
                        name="cancel" 
                        id="cancel"
                        class="btn btn-sm ma-gray-btn mx-auto"
                        @click="closeModal">
                        Close
                    </button>                    
                </div>
            </div>
        </div>
    </div>
</div>
</template>

<script>
import Vue from 'vue/dist/vue.esm';
export default {
  props: [
    'isModalVisible',
    'modalTitle',
    'modalType'
    ],
  data() {
    return {
        loading: false,
    }
  },
  methods: {
    closeModal() {
      this.$emit('close');
    },
    submit() {
      this.$parent.submitContact();
    }
  },
}
</script>

<style scoped>
.modal-mask {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  margin: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, .5);
  transition: opacity .3s ease;
  overflow-y: scroll;
}
.modal-container {
  position: fixed;
  left: 50%;
  top: 50%;
  -ms-transform: translate(-50%, -50%);
  -moz-transform: translate(-50%, -50%);
  -webkit-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
  width: 500px;
  height: auto;
  overflow-y: auto;
  padding: 20px 30px;
  background-color: #fff;
  border-radius: 2px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, .33);
  transition: all .3s ease;
  font-family: Helvetica, Arial, sans-serif;
}
.modal-body {
  margin: 0px;
  padding: 10px;
}
.modal-header .sub-heading {
  background-color: #FFF;
  color: #555;
}
.modal-header {
  padding: 5px;
}
.modal-header .close {
  margin: -1.5rem -2rem -1rem auto;
}
.history-table-wrapper {
  height: 350px;
  overflow-y: auto;
}
.modal-footer {
  border-top: none;
}
.btn-danger {
  background-color: #00ACEE;
  border-color: #00ACEE;
}
.modal-title {
  color: #7d7d7d;
  font-size: 14px;
  font-weight: 900;
}
.modal-header {
  border-bottom: 0px;
  margin-bottom: 10px;
}
.modal-body {
  padding: 5px;
}
.ma-send-email-btn {
  color: #FFF; 
  background-color: #00acee !important;
  border: 1px solid #00acee !important;
  font-weight: 900;
  width: 150px;
}
.form-control { font-size: 14px; }
.hide_vmessage {
  display: none !important;
}
.show_vmessage {
  display: block !important;
}
@media (min-width: 320px) and (max-width: 991px) { 
  .modal-container {
    width: 100%;
  }
}
.ma-blue-btn, .ma-blue-btn:focus, .ma-blue-btn:active, .ma-blue-btn:hover {
  color: #FFF !important;
  background: #00ACEE !important;
  border: 1px solid #00ACEE !important;
  padding: 5px;
  width: 150px;
}
.ma-gray-btn, .ma-gray-btn:focus, .ma-gray-btn:active, .ma-gray-btn:hover {
  color: #707070;
  width: 150px;
  padding: 5px;
}
</style>


// WEBPACK FOOTER //
// src/components/admin/admin_email_confirm_modal.vue